package com.essntl.core.axus.domain

import com.essntl.core.utils.utils.formatIntMoney
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import kotlinx.serialization.Serializable

@Serializable
data class AxusItinerary(
    val title: String,
    val subtitle: String,
    val startDate: String,
    val endDate: String,
    val status: String,
    val deleteMissingBookings: Boolean = false,
    val misc: String? = null,
    val itineraryFor: String,
    val image: String? = null,
    val itineraryPrice: String,
    val internalNotes: String? = null,
    val collaboratorNotes: String? = null,
    val collaborators: List<Collaborator>?,
    val travelers: List<Traveler>,
    val bookings: List<Booking>,
) {
    companion object {
        val testPushItinerary =
            AxusItinerary(
                title = "Bibi in Normandy",
                subtitle = "first test",
                startDate = "2024-03-01",
                endDate = "2024-03-28",
                status = "APPROVED",
                itineraryFor = "Sami Daik",
                itineraryPrice = "123.45",
                collaborators = emptyList(),
                travelers = emptyList(),
                bookings = emptyList(),
            )
    }
}

@Serializable
data class Collaborator(
    val name: String,
    val email: String,
    val consultantCrm: String,
)

@Serializable
data class Traveler(
    val firstName: String,
    val lastName: String,
    val primaryEmail: String,
    val secondaryEmail: String,
    val phoneNumber: String,
    val thirdPartyId: String,
    val travelerCrm: String,
)

@Serializable
data class Booking(
    val type: String,
    val reservationNumber: String,
    val name: String,
    // "2022-01-07T16:00:00-08:00"
    val startDate: String,
    // "$10"
    val bookingPrice: String,
)

object ProposalServiceToBookingMapper {
    fun map(
        proposalService: ProposalServiceModel,
        category: String,
    ): Booking {
        return Booking(
            // map our categories to Axus types
            type = category,
            // proposalService.purchaseOrderNumber
            reservationNumber = "",
            // get service name
            name = proposalService.service.title,
            startDate = proposalService.startDate,
            bookingPrice = formatIntMoney(proposalService.price ?: 0),
        )
    }
}
